import styled from 'styled-components';

export const CarouselContainer = styled.div(() => ({
    width: "100%",
    overflow: "hidden",
    position: "relative",
}))

export const SlideWrapper = styled.div(({ activeIndex }) => ({
    display: "flex",
    transition: "transform 0.5s ease-in-out, padding 0.5s ease",
    transform: `translateX(-${activeIndex * 100}%)`,
}))

export const Slide = styled.div(({ theme, spacing, justifyContent, isActiveIndex }) => ({
    gap: `${spacing}px`,
    display: "flex",
    justifyContent: "center",
    flex: "0 0 100%",
    boxSizing: "border-box",
    flexDirection: "row",
    opacity: isActiveIndex ? "1" : "0",
    height: isActiveIndex ? 'inherit' : '0',

    [theme.breakpoint.lg()]: {
        justifyContent: justifyContent || 'center',
        height: 'inherit',
    },
}))

export const Navigation = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    paddingTop: "32px",

    [theme.breakpoint.lg()]: {
        gap: "20px",
    }
}))

export const NavigationButton = styled.button(({ direction, theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transform: `${direction === "left" ? "rotateY(180deg)" : "none"}`,
    border: "none",
    cursor: "pointer",
    background: "none",
    color: theme.color.brandPrimary.light
}))

export const IndicatorWrapper = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
}))


export const Indicator = styled.div(({ isActive, theme }) => ({
    width: `${isActive ? "40px" : "24px"}`,
    height: "8px",
    backgroundColor: theme.color.brandPrimary.light,
    opacity: `${isActive ? "1" : "0.2"}`,
    borderRadius: "8px",
    transition: "width 0.5s ease, opacity 0.5s ease, background-color 0.5s ease",
    cursor: "pointer",

    [theme.breakpoint.lg()]: {
        width: `${isActive ? "48px" : "24px"}`,
    }
}))